import styled from 'styled-components';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';

const Container = styled(FlexBoxColumn)`
  width: 360px;
  box-sizing: border-box;
  background-color: ${(props) => props.theme.color.background.white};
`;

export { Container };
